import React from "react";
import ReactQuill from "react-quill";
import { Card, CardBody, Form, FormInput ,DatePicker} from "shards-react";
import FileUpload from "./FileUpload";
import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";

const Editor = ({type,handleChange,handleEditorChange,item,onFileUpload,fileUrl,handleDateChange}) => (
  <Card small className="mb-3">
    <CardBody>
    {type==="BLOG" ? 
      <Form className="add-new-post">
          <label>Blog Details</label>
        <FormInput size="lg" onChange={handleChange} name="title" 
                   value={item.title} className="mb-3" placeholder="Your Post Title" />
        <FormInput onChange={handleChange} name="subTitle" 
                   value={item.subTitle} size="lg" className="mb-3" placeholder="Your Post Sub Title" />
        <ReactQuill onChange={(v)=>handleEditorChange(v,'description')} value={item.description || ''} name="description" 
                    className="add-new-post__editor mb-3" />
    
        <FormInput size="lg" onChange={handleChange} name="postBy" 
                   value={item.postBy}  className="mb-3" placeholder="Post By" /> 
        <FormInput size="md"  onChange={handleChange} name="readTime" 
                   value={item.readTime}  className="mb-3" placeholder="Read Time" /> 
      
      
        <FileUpload imageSrc={fileUrl!=="" ? fileUrl : item.blogImage} onFileUpload={(e)=>onFileUpload(e,'blogImage')}/>
        <FormInput size="md"  onChange={handleChange} name="imageCredit" 
                   value={item.imageCredit} className="mb-3 mt-3" placeholder="Image Credit" /> 
       

      </Form>
       :   <Form className="add-new-post">
     <label>Author Details</label>
       <FormInput size="lg"  onChange={handleChange} name="authorName" 
                   value={item.authorName}  className="mb-3" placeholder="Author Name" />
       <ReactQuill onChange={(v)=>handleEditorChange(v,'authorDescription')} value={item.authorDescription || ''}   className="add-new-post__editor mb-1" />
       <FormInput onChange={handleChange} name="contentSource" 
                   value={item.contentSource}  size="lg" className="mb-3" placeholder="Content Source" /> 
        <FileUpload imageSrc={fileUrl!=="" ? fileUrl : item.authorImage} onFileUpload={(e)=>onFileUpload(e,'authorImage')}/>
      
     </Form> }
    </CardBody>
  </Card>
);

export default Editor;
